/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ChangeOrderWorkflowStatusDto } from '../../models/change-order-workflow-status-dto';
import { OrderItemDetail } from '../../models/order-item-detail';

export interface OrderControllerChangeOrderWorkflowStatus$Params {
  id: number;
      body: ChangeOrderWorkflowStatusDto
}

export function orderControllerChangeOrderWorkflowStatus(http: HttpClient, rootUrl: string, params: OrderControllerChangeOrderWorkflowStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
  const rb = new RequestBuilder(rootUrl, orderControllerChangeOrderWorkflowStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderItemDetail;
      }>;
    })
  );
}

orderControllerChangeOrderWorkflowStatus.PATH = '/order/change-order-status/{id}';
